export const ApplicationConstants = {
    ENCRYPT_KEY: "SomeProject$",
    ACCESS_TOKEN_KEY: "token",
    ACTIVE_USER_USERNAME: "username"
}
